import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { TableBody } from './Table.Body/Table.Body.es.js';
import { TableProvider } from './Table.Context/provider.es.js';
import { TableHead } from './Table.Head/Table.Head.es.js';

const Table = ({ className, children, density = 'default', groupHeaderVariant = 'primary', hoverHighlight = false, layout = 'fixed', loading = false, numLoadingColumns, numLoadingRows = 5, ...props })=>jsx(TableProvider, {
        density: density,
        groupHeaderVariant: groupHeaderVariant,
        hoverHighlight: hoverHighlight,
        loading: loading,
        numLoadingColumns: numLoadingColumns,
        numLoadingRows: numLoadingRows,
        children: jsx("table", {
            className: classNames('cb-table', className, `layout-${layout}`),
            ...props,
            children: children
        })
    });
Table.displayName = 'Table';
Table.Head = TableHead;
Table.Body = TableBody;

export { Table, Table as default };
//# sourceMappingURL=Table.es.js.map
